<template>
  <figure
    :class="['lazy-image', 'lazy-image--slide-' + side]"
    v-lazyload="{ side: side }"
  >
    <img class="image__item" :data-url="source" alt="" />
    <div class="_img-title" v-if="title" v-html="title"></div>
  </figure>
</template>

<script>
export default {
  name: "ImageReveal",
  props: {
    source: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    side: {
      type: String,
      required: false,
    },
  },
}
</script>
